import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {calendarDate} from 'shared/tools';
import {Employee} from 'main/stores/employees';
import Survey from './Survey';

class SurveyEmployeeStatus extends DomainObject {
  submittedAt;
  employee;
  dueDate;
  submitted;

  _relations = {
    employee: Employee,
    survey: Survey,
    _dates: ['submittedAt', 'dueDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      submittedAt: observable,
      employee: observable,
      dueDate: observable,
      submitted: observable,
      dueDateView: computed,
      submittedAtView: computed
    });

    this.merge(other);
  }

  get dueDateView() {
    if (!this.dueDate) return null;

    return calendarDate(this.dueDate);
  }

  get submittedAtView() {
    if (!this.submittedAt) return null;

    return calendarDate(this.submittedAt);
  }
}

export default SurveyEmployeeStatus;
